import { defineMessages } from 'react-intl'

export default defineMessages({

  'consentsAcceptAll': {
    id: 'privacy_center.consents.accept_all',
    defaultMessage: 'You must accept all required consents before we can continue.',
  },

})
